module.exports = __webpack_public_path__ + "static/img/xg2-2.ffcc66d.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/xg2-2.png
// module id = 738
// module chunks = 0